import React, { Component } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import './index.css';
import AuthService from '../../components/AuthService';
import { createBrowserHistory } from 'history';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import 'moment/locale/ru';
import {
  Form,
  Input,
  Select,
  Button,
  message,
  Card
} from 'antd';

const history = createBrowserHistory();


const { Option } = Select;

class ForgotPassword extends Component {
  formRef = React.createRef();

  state = {
    email: "",
    recaptchaSite: "",
    success: false,
  }

  captcha = undefined;

  static defaultProps = {
    auth: new AuthService()
  };
  // static getDerivedStateFromProps(props, state) {
  componentWillMount() {
    const { auth } = this.props

    auth.fetch('/api/recaptcha/site').then(res => {
      if (res && res.data) {
        this.setState({ recaptchaSite: res.data });
      }
    });
  }

  handleSubmit = (values) => {
    this.props.auth.forgotPassword(values)
      .then(res => {
        if (!res.status) {
          if (this.captcha) {
            this.captcha.reset();
          }
          //Валидация (подумать как сделать универсально)
          //Чистим ошибки предыдущей валидации
          this.formRef.current.setFieldsValue(this.formRef.current.getFieldsValue());
          //Показываем новые ошибки
          if (res.invalid && res.invalid.errors) {
            var object = res.invalid.errors
            for (const key in object) {
              if (object.hasOwnProperty(key)) {
                const element = object[key];
                if (element && element.length) {
                  var valData = [];
                  valData.push({
                    name: key,
                    errors: [element[0].message],
                    value: (element[0].value) ? element[0].value : ""
                  })
                  this.formRef.current.setFields(valData);
                }
              }
            }
          }
          message.error(res.message);
        } else {
          this.setState({ success: true });
        }
      })
      .catch(err => {
        if (this.captcha) {
          this.captcha.reset();
        }
        console.log(err)
      })
  };

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 20,
          offset: 4,
        },
      },
    };

     return (
      <div style={{
        height: "calc(100vh - 12px)",
        backgroundColor: (this.props.mobile) ? "white" : "#f5f5f5",
        margin: "5px",
        borderRadius: "5px"
      }}>
        
        <div style={{paddingTop: "25px", textAlign: "center"}}>
          <a href="/">
            <img src="/resources/logo.svg" alt="Logo" />
          </a>
        </div>

        {!this.state.success && <Form ref={this.formRef} name="forgotPassword" {...formItemLayout}
          onFinish={this.handleSubmit}
          onFinishFailed={({ errorFields }) => {
            this.formRef.current.scrollToField(errorFields[0].name);
          }}
          className="register-form"
          style={{ maxWidth: (this.props.mobile) ? "300px" : "600px", paddingTop: "5px" }}
          
          initialValues={{
            genderID: '1',
            tipTelefonaID: '1',
          }}
        >
          <div style={{
            backgroundColor: "white",
            padding: (this.props.mobile) ? "0px" : "25px",
            boxShadow: "1px 1px 8px 0px rgba(34, 60, 80, 0.2)",
            borderRadius: "5px"
          }}>
            <div style={{paddingBottom: "25px"}}>Для восстановления пароля, необходимо указать адрес электронной почты, зарегистрированный в agro-platform.ru</div>
            <Form.Item label="E-mail"
              name="email"
              rules={[
                {
                  type: 'email',
                  message: 'Введен неверный E-mail!',
                },
                {
                  required: true,
                  message: 'Пожалуйста, введите свой E-mail!',
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item {...tailFormItemLayout}
              name="captcha"
              rules={[{ required: true, message: 'Мы должны убедиться, что вы человек!' }]}
            >
              <ReCAPTCHA
                ref={e => (this.captcha = e)}
                sitekey={this.state.recaptchaSite}
              />
            </Form.Item>
            <Form.Item {...tailFormItemLayout}>
              <Button type="primary" htmlType="submit">
                Отправить
          </Button>
            </Form.Item>
          </div>
        </Form>}
        {this.state.success && <div className="register-form">
          <Card>
            <div>
              На Ваш адрес электронной почты было отправлено письмо с инструкцией для восстановления пароля.
            </div>
            <div style={{paddingTop: "25px"}}>
              <a href="/app/login">Вернуться на страницу входа</a>
            </div>
          </Card>
          </div>}
      </div>
    );
  }
}

export default ForgotPassword;